import React from 'react';
import { Link } from 'react-router-dom';
import { shopTrueEmptySotHref } from './createShopJob';
import { shopJobsSotHref } from './jobsSurface';

const TrueEmptySwitcher = ({ active }) => (
    <nav
        className="jobs-sot-switcher"
        data-testid="true-empty-switcher"
        aria-label="True-empty create walk"
    >
        <Link
            className={`jobs-sot-link${active === 'walk' ? ' is-active' : ''}`}
            to={shopTrueEmptySotHref('walk')}
        >
            TRUE EMPTY · WALK
        </Link>
        <Link className="jobs-sot-link" to={shopJobsSotHref('empty')}>
            CREATE · SOT
        </Link>
        <Link className="jobs-sot-link" to="/app/jobs">
            Exit walk
        </Link>
    </nav>
);

export default TrueEmptySwitcher;
